(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('EwsSeries', EwsSeries);

    EwsSeries.$inject = ['$resource', 'DateUtils'];

    function EwsSeries ($resource, DateUtils) {
        var resourceUrl =  'api/timeseries-data/ews';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
